/* NANIMERICA Black Swordsman landing: tile options (material chips, size select), price per choice, quick add (Baseline cart drawer). */
(function () {
  if (window.nrBs) return;
  var SECTIONS = 'cart-items,cart-footer,cart-item-count,cart-live-region';

  function data(t) {
    if (!t.nrV) { try { t.nrV = JSON.parse(t.querySelector('[data-v]').textContent); } catch (e) { t.nrV = []; } }
    return t.nrV;
  }
  function chosen(t) {
    var vs = data(t), n = vs.length ? vs[0].o.length : 0, sel = [];
    for (var i = 0; i < n; i++) sel.push(null);
    t.querySelectorAll('[data-nrbs-chip][aria-checked="true"]').forEach(function (b) { sel[+b.getAttribute('data-nrbs-chip')] = b.getAttribute('data-val'); });
    t.querySelectorAll('[data-nrbs-opt]').forEach(function (s) { sel[+s.getAttribute('data-nrbs-opt')] = s.value || null; });
    /* options with a single value are fixed */
    for (var j = 0; j < n; j++) if (sel[j] === null) {
      var vals = {}; vs.forEach(function (v) { vals[v.o[j]] = 1; });
      var k = Object.keys(vals); if (k.length === 1) sel[j] = k[0];
    }
    return sel;
  }
  function match(t, sel) {
    var vs = data(t);
    for (var i = 0; i < vs.length; i++) {
      var ok = true;
      for (var j = 0; j < sel.length; j++) if (sel[j] !== null && vs[i].o[j] !== sel[j]) { ok = false; break; }
      if (ok) return vs[i];
    }
    return null;
  }
/* once per tile: cheapest in-stock option preselected + View details link */ function prep(t) { if (t.nrPrep) return; t.nrPrep = true; var vs = data(t), url = t.getAttribute('data-url'); var num = function (p) { return parseFloat(String(p).replace(/[^0-9.]/g, '')) || 0; }; var best = null; vs.forEach(function (v) { if (v.a && (!best || num(v.p) < num(best.p))) best = v; }); if (best) t.querySelectorAll('[data-nrbs-chip]').forEach(function (b) { b.setAttribute('aria-checked', best.o[+b.getAttribute('data-nrbs-chip')] === b.getAttribute('data-val') ? 'true' : 'false'); }); var btn = t.querySelector('[data-nrbs-add]'); if (url && btn) { var a = document.createElement('a'); a.href = url; a.className = 'nrbs-det'; a.textContent = 'View details →'; a.style.cssText = 'display:block;margin:10px 0 0;padding:0;border:0;text-align:center;font-size:12px;line-height:1.4;letter-spacing:.02em;color:rgba(244,242,238,.62);text-decoration:underline;text-underline-offset:3px'; btn.insertAdjacentElement('afterend', a); } }
/* long product names shrink just enough to fit the card */ function fitName(t) { var nm = t.querySelector('.nrbs-tile__n'); if (!nm || nm.nrFit) return; nm.nrFit = true; var fit = function () { nm.style.fontSize = ''; var w = nm.clientWidth, s = nm.scrollWidth; if (s > w && w > 0) nm.style.fontSize = Math.max(13, Math.floor(parseFloat(getComputedStyle(nm).fontSize) * w / s * 10) / 10) + 'px'; }; fit(); if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit); window.addEventListener('resize', fit); }
/* sold-out sizes are marked and can't be picked */ function marks(t) { var vs = data(t), sel = chosen(t); t.querySelectorAll('[data-nrbs-opt]').forEach(function (s) { var j = +s.getAttribute('data-nrbs-opt'); [].forEach.call(s.options, function (o) { if (!o.value) return; if (o.nrT == null) o.nrT = o.textContent; var ok = vs.some(function (v) { if (v.o[j] !== o.value || !v.a) return false; for (var k = 0; k < sel.length; k++) if (k !== j && sel[k] !== null && v.o[k] !== sel[k]) return false; return true; }); o.disabled = !ok; o.textContent = ok ? o.nrT : o.nrT + ' (sold out)'; }); var so = s.options[s.selectedIndex]; if (so && so.disabled) s.value = ''; }); }
  function update(t) {
    fitName(t); prep(t); marks(t); var sel = chosen(t), v = match(t, sel), btn = t.querySelector('[data-nrbs-add]'), lab = btn.querySelector('span');
    var need = sel.indexOf(null) !== -1;
    var pr = t.querySelector('[data-nrbs-price]');
    if (v) {
      pr.textContent = '';
      if (v.w) { var s = document.createElement('s'); s.className = 'nrcp-was'; s.textContent = v.w; pr.appendChild(s); }
      pr.appendChild(document.createTextNode(v.p));
    }
    var low = t.querySelector('[data-nrbs-low]');
    if (low) { var q = v && !need && v.a ? v.q : 0; low.hidden = !q; low.textContent = q ? 'Only ' + q + ' left' : ''; }
    btn.classList.toggle('is-pick', need);
    if (need) { btn.disabled = false; btn.removeAttribute('data-id'); lab.textContent = 'Pick a size'; return; }
    if (!v || !v.a) { btn.disabled = true; btn.removeAttribute('data-id'); lab.textContent = 'Sold out'; return; }
    btn.disabled = false; btn.setAttribute('data-id', v.id); lab.textContent = 'Add · ' + v.p;
    var sz = t.querySelector('.nrbs-sel'); if (sz) sz.classList.remove('is-need');
  }

  function add(btn) {
    var t = btn.closest('[data-nrbs-tile]');
    if (btn.classList.contains('is-pick')) {
      var sz = t.querySelector('.nrbs-sel');
      if (sz) { sz.classList.add('is-need'); var s = sz.querySelector('select'); s.focus(); try { s.showPicker && s.showPicker(); } catch (e) {} }
      return;
    }
    var id = btn.getAttribute('data-id');
    if (!id || btn.disabled || btn.classList.contains('is-busy')) return;
    var label = btn.querySelector('span'), old = label.textContent;
    var err = btn.parentNode.querySelector('.nrcp-err'); if (err) err.remove();
    btn.classList.add('is-busy'); label.textContent = 'Adding';
    var payload = { id: Number(id), quantity: 1, sections: SECTIONS, sections_url: location.pathname };
    /* local ring size (UK / AU / EU) goes with the line, as on the product page */
    var ps = t.querySelector('[data-nrbs-prop]');
    if (ps && ps.value) { var o = ps.options[ps.selectedIndex], loc = o && o.getAttribute('data-loc'); if (loc) { payload.properties = {}; payload.properties[ps.getAttribute('data-nrbs-prop')] = loc; } }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        btn.classList.remove('is-busy');
        if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Could not add');
        btn.classList.add('is-done'); label.textContent = 'Added';
        setTimeout(function () { btn.classList.remove('is-done'); update(t); }, 2200);
        try {
          window.dispatchEvent(new CustomEvent('baseline:cart:afteradditem', { detail: { response: res.j, originalTarget: btn } }));
          if (window.Alpine && Alpine.store('modals')) Alpine.store('modals').open('cart');
        } catch (e) { location.href = '/cart'; }
      })
      .catch(function (e) {
        btn.classList.remove('is-busy'); label.textContent = old;
        var p = document.createElement('p'); p.className = 'nrcp-err'; p.textContent = e.message;
        btn.insertAdjacentElement('afterend', p);
      });
  }

  /* clips load only when they come near the screen, and pause when they leave it */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (!v.getAttribute('src')) { v.src = v.getAttribute('data-src'); v.preload = 'auto'; }
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else if (v.getAttribute('src')) { v.pause(); }
    });
  }, { rootMargin: '300px 0px' }) : null;
  function lazy(v) {
    if (v.nrLazy) return; v.nrLazy = true;
    if (io) io.observe(v); else { v.src = v.getAttribute('data-src'); v.autoplay = true; }
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('[data-nrbs-tile]').forEach(function (t) { if (t.nrReady) return; t.nrReady = true; update(t); });
    root.querySelectorAll('video[data-nrbs-lazy]').forEach(lazy);
  }

  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-nrbs-chip]');
    if (c) {
      var g = c.parentNode;
      g.querySelectorAll('[data-nrbs-chip]').forEach(function (b) { b.setAttribute('aria-checked', b === c ? 'true' : 'false'); });
      update(c.closest('[data-nrbs-tile]'));
      return;
    }
    var snd = e.target.closest('[data-nrbs-snd]');
    if (snd) {
      var vid = snd.parentNode.querySelector('video'), on = vid.muted;
      vid.muted = !on; if (on) { var pp = vid.play(); if (pp && pp.catch) pp.catch(function () {}); }
      snd.setAttribute('aria-pressed', on ? 'true' : 'false'); snd.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on');
      return;
    }
    var a = e.target.closest('[data-nrbs-add]');
    if (a) { e.preventDefault(); add(a); }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-nrbs-opt]')) update(e.target.closest('[data-nrbs-tile]'));
  });

  window.nrBs = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
